import { useEffect, useMemo, useRef } from 'react';

import { useStoreContext } from 'features/store';

import { useServiceModeContext } from 'state/service-mode';
import { logger } from 'utils/logger';

import { useIsStoreUnavailable } from './use-is-store-unavailable';

const LOG_MESSAGE = 'Store Order Unavailable: Order cannot be completed at current store';

export const useOrderErrorLogging = (
  isDialogOpen: boolean,
  storeUnavailableData: ReturnType<typeof useIsStoreUnavailable>
) => {
  const { store } = useStoreContext();
  const { serviceMode } = useServiceModeContext();
  const hasLoggedRef = useRef(false);

  const context = useMemo(
    () => ({
      ...storeUnavailableData,
      storeId: store?._id,
      storeStatus: store?.status,
      serviceMode,
    }),
    [store, serviceMode, storeUnavailableData]
  );

  useEffect(() => {
    if (isDialogOpen && !hasLoggedRef.current) {
      hasLoggedRef.current = true;
      logger.error({
        message: LOG_MESSAGE,
        isErrorModal: true,
        context: {
          ...context,
          isOrderCouldNotBeCompletedError: true,
        },
      });
    }

    if (!isDialogOpen) {
      hasLoggedRef.current = false;
    }
  }, [isDialogOpen, context]);
};
